import React, { useState, useEffect } from 'react';
import { getGlobalSettings } from '../api';

export default function PrivacyScreen() {
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getGlobalSettings()
      .then(r => setText(r.data?.privacyText || ''))
      .catch(() => setText(''))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth:800, margin:'0 auto', padding:'40px 24px' }}>
      <h1 style={{ fontSize:24, fontWeight:700, marginBottom:8 }}>Privacy Statement</h1>
      <p style={{ color:'var(--text2)', fontSize:13, marginBottom:32 }}>Solidiphy</p>
      {loading ? null : text ? (
        <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:28 }}>
          <div className="rich-content" dangerouslySetInnerHTML={{ __html: text }} />
        </div>
      ) : (
        <div style={{ background:'var(--bg)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:40, textAlign:'center', color:'var(--text3)' }}>
          <div style={{ fontSize:32, marginBottom:12 }}>🔒</div>
          <div style={{ fontSize:16, fontWeight:500, marginBottom:8 }}>Privacy Statement</div>
          <div style={{ fontSize:13 }}>No privacy document available yet.</div>
        </div>
      )}
    </div>
  );
}
